import  { ActionType, Enum } from "./../resources/constants"

const { SET_ORIGIN, SET_ORIGIN_LOCATION, SET_DESTINATION, SET_DESTINATION_LOCATION, SET_OPEN_DRAWER, SET_OPEN_TOUR, SET_DIRECTIONS, SET_START_DIRECTIONS_ICON, SET_END_DIRECTIONS_ICON, SET_FORM, SET_USER, SET_TRAVEL, SET_TRAVEL_MOD, SET_TRAVEL_TYPE, SET_IS_OPEN_FLOAT_BUTTON, SET_PROVINCES, SET_CARS, SET_FILTER, SET_OWNERS } = ActionType
const { TravelType } = Enum

export default function GlobalReducer(state: any, action: { type: string, payload?: any }) {
    switch (action.type) {
        case SET_ORIGIN:
            return setOrigin(state , action);
        case SET_ORIGIN_LOCATION:
            return setOriginLocation(state , action);
        case SET_DESTINATION:
            return setDestination(state,action);
        case SET_DESTINATION_LOCATION:
            return setDestinationLocation(state,action);
        case SET_OPEN_DRAWER:
            return setOpenDrawer(state,action);
        case SET_DIRECTIONS:
            return setDirections(state,action);
        case SET_START_DIRECTIONS_ICON:
            return setStartDirectionsIcon(state,action);
        case SET_END_DIRECTIONS_ICON:
            return setEndDirectionsIcon(state,action);
        case SET_FORM:
            return setForm(state,action);
        case SET_USER:
            return setUser(state,action);
        case SET_TRAVEL:
            return setTravel(state,action);
        case SET_TRAVEL_TYPE:
            return setTravelType(state,action);
        case SET_TRAVEL_MOD:
            return setTravelMod(state,action);
        case SET_OPEN_TOUR:
            return setOpenTour(state,action);
        case SET_IS_OPEN_FLOAT_BUTTON:
            return setIsOpenFloatButton(state,action);
        case SET_PROVINCES:
            return setProvinces(state,action);
        case SET_OWNERS:
            return setOwners(state,action);
        case SET_CARS:
            return setCars(state,action);
        case SET_FILTER:
            return setFilter(state,action);
        default:
            return state;
    }
}

const setOrigin = (state: any, action: { type: string, payload?: any }) => {
    const { origin } = action.payload;
    return {
        ...state,
        origin
    }
}

const setOriginLocation = (state: any, action: { type: string, payload?: any }) => {
    const { originLocation } = action.payload;
    return {
        ...state,
        originLocation
    }
}

const setDestination = (state: any, action: { type: string, payload?: any } ) => {
    const { destination } = action.payload;

    return {
        ...state,
        destination
    }
}

const setDestinationLocation = (state: any, action: { type: string, payload?: any } ) => {
    const { destinationLocation } = action.payload;

    return {
        ...state,
        destinationLocation
    }
}

const setOpenDrawer = (state: any, action: { type: string, payload?: any } ) => {
    const { openDrawer } = action.payload;
    const { travel } = state;
    const { personPrice = 0, closePrice = 0, homePrice = 0 } = travel
    const travelPrice = [
        {
            name: TravelType.Person,
            price: personPrice,
        },
        {
            name: TravelType.Close,
            price: closePrice,
        },
        {
            name: TravelType.Home,
            price: homePrice,
        },
    ].filter(({ price }) => price)

    if (openDrawer) return resetDirections(state, action.payload)
    else return {
        ...state,
        travelType: travel.travelType || (travelPrice.length ? travelPrice[0].name : TravelType.Person),
        openDrawer
    }
}

const setDirections = (state: any, action: { type: string, payload?: any } ) => {
    const { directions } = action.payload;

    return {
        ...state,
        directions
    }
}

const setStartDirectionsIcon = (state: any, action: { type: string, payload?: any } ) => {
    const { startDirectionsIcon } = action.payload;

    return {
        ...state,
        startDirectionsIcon
    }
}

const setEndDirectionsIcon = (state: any, action: { type: string, payload?: any } ) => {
    const { endDirectionsIcon } = action.payload;

    return {
        ...state,
        endDirectionsIcon
    }
}

const resetDirections = (state: any, payload?: any) => {
    const { startDirectionsIcon, endDirectionsIcon  } = state

    if (startDirectionsIcon && endDirectionsIcon) {
        startDirectionsIcon.setMap(null)
        endDirectionsIcon.setMap(null)
    }

    return {
        ...state,
        origin: null,
        destination: null,
        directions: { routes: [] },
        ...payload
    }
}

const setForm = (state: any, action: { type: string, payload?: any } ) => {
    const { form } = action.payload;

    return {
        ...state,
        form
    }
}

const setUser = (state: any, action: { type: string, payload?: any } ) => {
    const { user } = action.payload;

    return {
        ...state,
        user
    }
}

const setTravel = (state: any, action: { type: string, payload?: any } ) => {
    const { travel } = action.payload;
    const { personPrice = 0, closePrice = 0, homePrice = 0 } = travel
    const travelPrice = [
            {
                name: TravelType.Person,
                price: personPrice,
            },
            {
                name: TravelType.Close,
                price: closePrice,
            },
            {
                name: TravelType.Home,
                price: homePrice,
            },
        ].filter(({ price }) => price)

    return {
        ...state,
        travelType: travel.travelType || (travelPrice.length ? travelPrice[0].name : TravelType.Person),
        travel
    }
}

const setTravelType = (state: any, action: { type: string, payload?: any } ) => {
    const { travelType } = action.payload;

    return {
        ...state,
        travelType
    }
}

const setTravelMod = (state: any, action: { type: string, payload?: any } ) => {
    const { travelMod } = action.payload;

    return {
        ...state,
        travelMod
    }
}

const setIsOpenFloatButton = (state: any, action: { type: string, payload?: any } ) => {
    const { isOpenFloatButton } = action.payload;

    return {
        ...state,
        isOpenFloatButton
    }
}

const setOpenTour = (state: any, action: { type: string, payload?: any } ) => {
    const { openTour } = action.payload;

    return {
        ...state,
        openTour
    }
}

const setProvinces = (state: any, action: { type: string, payload?: any }) => {
    const { provinces } = action.payload;
    return {
        ...state,
        provinces
    }
}

const setOwners = (state: any, action: { type: string, payload?: any }) => {
    const { owners } = action.payload;
    return {
        ...state,
        owners
    }
}

const setCars = (state: any, action: { type: string, payload?: any }) => {
    const { cars } = action.payload;
    return {
        ...state,
        cars
    }
}

const setFilter = (state: any, action: { type: string, payload?: any }) => {
    const { filter } = action.payload;
    return {
        ...state,
        filter
    }
}
